export default __webpack_public_path__ + "assets/38c14f850038ca877c0594f3ad5cbb0e.jpg";